// chakra imports
import { Box, Flex, Stack } from "components-lib";
//   Custom components
import Brand from "components/sidebar/components/Brand";
import Links from "components/sidebar/components/Links";
import GoogleCalendarWidget from "views/admin/settings/components/GoogleCalendarWidget.jsx";
// SidebarCard removed along with Horizon demo assets
import React from "react";

// FUNCTIONS

function SidebarContent(props) {
  const { routes } = props;
  // SIDEBAR
  return (
    <Flex
      direction="column"
      height="100%"
      pt="25px"
      px="2px"
      borderRadius="30px"
    >
      <Brand />
      <Stack direction="column" mb="auto" mt="8px">
        <Box ps="20px" pe={{ md: "16px", "2xl": "1px" }}>
          <Links routes={routes} />
        </Box>
      </Stack>
      <GoogleCalendarWidget />

      {/* Horizon demo SidebarCard removed */}
    </Flex>
  );
}

export default SidebarContent;
